import React, { useState } from "react";

import { Box } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import GetAppIcon from "@material-ui/icons/GetApp";

import { toastr } from "react-redux-toastr";

const useStyles = makeStyles({
  downloadButton: {
    display: "flex",
    color: "#3E3E3E",
    fontSize: 15,
    cursor: "pointer",
  },
});

export default ({ quote }) => {
  const classes = useStyles();
  const [isDownloading, setIsDownloading] = useState(false);

  const documentType = quote.quote_accepted ? "invoice" : "pdf";
  const url = quote.id && `${process.env.REACT_APP_API_URL}/payment/quotebilling/${quote.id}/${documentType}/`;

  const getFilenameFromResponse = (response) => {
    const contentDisposition = response.headers.get("content-disposition") || "";
    const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    if (filenameMatch && filenameMatch[1]) return filenameMatch[1];
    return quote.quote_accepted ? `facture_${quote.uuid}.pdf` : `devis_${quote.uuid}.pdf`;
  };

  const getButtonTitle = () => {
    if (quote.quote_accepted) return "Facture";
    if (quote.quote_refused) return "Devis refusé";
    if (quote.sent) return "Devis envoyé";
    return "Devis émis";
  };

  const displayDownloadError = (status) => {
    if (status === 401 || status === 403) {
      toastr.error("Téléchargement impossible", "Accès non autorisé");
      return;
    }
    if (status === 404) {
      toastr.error("Téléchargement impossible", "Document introuvable");
      return;
    }
    toastr.error("Téléchargement impossible", "Une erreur est survenue");
  };

  const download = async () => {
    if (!url || isDownloading) return;

    setIsDownloading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Token ${token}`,
        },
      });

      if (!response.ok) {
        displayDownloadError(response.status);
        return;
      }

      const blob = await response.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      const filename = getFilenameFromResponse(response);

      const element = document.createElement("a");
      element.setAttribute("href", objectUrl);
      element.setAttribute("download", filename);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
      window.URL.revokeObjectURL(objectUrl);
    } catch (_error) {
      toastr.error("Téléchargement impossible", "Une erreur est survenue");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Tooltip title={`Télécharger ${quote.quote_accepted ? "la facture" : "le devis"}`}>
      <div onClick={download} className={classes.downloadButton}>
        <Box mx={2}>{getButtonTitle()}</Box> <GetAppIcon />
      </div>
    </Tooltip>
  );
};
